module.exports = __webpack_public_path__ + "img/8.d6455a4a.png";